var _style, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 320.9 75.7",
    style: {
      enableBackground: "new 0 0 320.9 75.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000138549604940505909390000013754679784754807451_);}\r\n\t\r\n\t\t.st1{clip-path:url(#SVGID_00000142895456155248719350000007112110679517521822_);fill:url(#SVGID_00000158740854677171826660000005298772847131153067_);}\r\n\t\r\n\t\t.st2{clip-path:url(#SVGID_00000150101379829734472240000017867993881766972349_);fill:url(#SVGID_00000022532012591242313690000015476888906008071572_);}\r\n\t\r\n\t\t.st3{clip-path:url(#SVGID_00000071530803020280889210000001720643395248126373_);fill:url(#SVGID_00000153686221872912617070000004309665967481311930_);}\r\n\t\r\n\t\t.st4{clip-path:url(#SVGID_00000051372331687380267550000013082899671660818832_);fill:url(#SVGID_00000148632341133144811300000009525391657261503631_);}\r\n\t\r\n\t\t.st5{clip-path:url(#SVGID_00000031918093638107427160000014343830456336486031_);fill:url(#SVGID_00000034776810261277674870000008773696515324292994_);}\r\n\t\r\n\t\t.st6{clip-path:url(#SVGID_00000002365087859464758920000000489858289325429148_);fill:url(#SVGID_00000028316738416249657560000010304255680466018464_);}\r\n\t.st7{clip-path:url(#SVGID_00000004537315911530642290000001578569016783048604_);fill:#455E2A;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Artwork_1_00000129888312752211715440000000514195202574651071_"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 9.5,
    y: 7.4,
    width: 301.9,
    height: 61
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147908497216134936980000000823870031381698708_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000147908497216134936980000000823870031381698708_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000031923038491533441090000015943793224907422370_",
    d: "M9.6,40.7c0.2,1.9,1.5,3.4,3.3,4l26.6,8 c0.5,0.2,1-0.3,0.9-0.8l-1.7-8.7c-0.4-2.3-2.1-4.1-4.3-4.7l-24.2-7.2C9.6,34.2,9.4,37.4,9.6,40.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005254015580052405170000010389875324780534682_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031923038491533441090000015943793224907422370_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058586285509704996220000003558011767048465587_",
    gradientUnits: "userSpaceOnUse",
    x1: -566.6248,
    y1: -312.6867,
    x2: -565.5631,
    y2: -312.6867,
    gradientTransform: "matrix(-27.1733 -25.4855 -25.4855 27.1733 -23325.9414 -5887.7783)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6DC067"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0933175,
    style: {
      stopColor: "#6DC067"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    style: {
      stopColor: "#FFC233"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC233"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000005254015580052405170000010389875324780534682_)",
      fill: "url(#SVGID_00000058586285509704996220000003558011767048465587_)"
    },
    points: " 25.9,68.4 -1.4,42.7 23.9,15.6 51.3,41.3  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000147908497216134936980000000823870031381698708_)"
    }
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000104679554115650254450000005540372393705263794_",
    d: "M40.7,68.4c1.6,0,2.7-1.5,2.4-3.1l-0.8-3.9 c-0.4-2.3-2.1-4.1-4.3-4.8l-26.5-8C16.1,61.1,28.1,68.7,40.7,68.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101819331232858525670000011374656296535052438_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000104679554115650254450000005540372393705263794_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138575221111540634210000006156473607032193941_",
    gradientUnits: "userSpaceOnUse",
    x1: -566.6248,
    y1: -312.627,
    x2: -565.5631,
    y2: -312.627,
    gradientTransform: "matrix(-27.1733 -25.4855 -25.4855 27.1733 -23331.5781 -5881.769)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6DC067"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0933175,
    style: {
      stopColor: "#6DC067"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    style: {
      stopColor: "#FFC233"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC233"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000101819331232858525670000011374656296535052438_)",
      fill: "url(#SVGID_00000138575221111540634210000006156473607032193941_)"
    },
    points: " 28.4,84.6 1.5,59.3 26.4,32.7 53.4,58  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000147908497216134936980000000823870031381698708_)"
    }
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000107547460236420356100000013039556855824967613_",
    d: "M49.1,11.6L26.4,30.1c-0.4,0.3-0.3,0.9,0.2,1.1l10,3.1 c2,0.6,4.1,0.2,5.7-1.1l19.5-16c-2.3-2.4-5-4.4-7.9-5.9c-0.6-0.3-1.4-0.5-2.1-0.5C50.9,10.6,49.9,11,49.1,11.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000122707559352880107560000008601265941777052578_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000107547460236420356100000013039556855824967613_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028326784620465416670000005375495677599505068_",
    gradientUnits: "userSpaceOnUse",
    x1: -570.207,
    y1: -327.3169,
    x2: -569.1453,
    y2: -327.3169,
    gradientTransform: "matrix(-7.0887 -23.2914 -23.2914 7.0887 -11618.998 -10929.0186)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC233"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3057,
    style: {
      stopColor: "#FFC233"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9067,
    style: {
      stopColor: "#F37021"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F37021"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000122707559352880107560000008601265941777052578_)",
      fill: "url(#SVGID_00000028326784620465416670000005375495677599505068_)"
    },
    points: " 29.1,44.8 19.3,12.7 58.8,0.6 68.6,32.7  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000147908497216134936980000000823870031381698708_)"
    }
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000093163991398774467050000011287141753512966824_",
    d: "M29.7,9.4c-7.5,2.7-13.2,7.9-16.6,14.4 c-0.7,1.4,0,3.2,1.5,3.6l3.5,1.1c2,0.6,4.1,0.2,5.7-1.1L46.9,8.4c-2.3-0.5-4.6-0.8-7-0.8C36.5,7.6,33.1,8.2,29.7,9.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165225966839676342810000012316866929624291721_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000093163991398774467050000011287141753512966824_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143602257717968508110000010526822594038928796_",
    gradientUnits: "userSpaceOnUse",
    x1: -570.207,
    y1: -327.2522,
    x2: -569.1453,
    y2: -327.2522,
    gradientTransform: "matrix(-7.0887 -23.2914 -23.2914 7.0887 -11629.4365 -10925.8418)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC233"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5022,
    style: {
      stopColor: "#FFC233"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9067,
    style: {
      stopColor: "#F37021"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F37021"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000165225966839676342810000012316866929624291721_)",
      fill: "url(#SVGID_00000143602257717968508110000010526822594038928796_)"
    },
    points: " 15.2,38.7 6.3,9.4 43.9,-2 52.8,27.3  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000147908497216134936980000000823870031381698708_)"
    }
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000019645365475631943640000007513087183749490324_",
    d: "M45,36.2c-1.8,1.5-2.7,3.8-2.2,6.1l5,25.1 c0.8-0.2,1.6-0.5,2.4-0.7c2.4-0.9,4.7-2,6.8-3.4c1.5-1,2.3-2.9,1.9-4.7l-5.7-28.8L45,36.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000117646226540142345840000016572236688491890818_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000019645365475631943640000007513087183749490324_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074407804821705941590000000574859568211470771_",
    gradientUnits: "userSpaceOnUse",
    x1: -548.9598,
    y1: -325.5017,
    x2: -547.8981,
    y2: -325.5017,
    gradientTransform: "matrix(23.4602 -35.9498 -35.9498 -23.4602 1222.2183 -27314.3438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6DC067"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0933175,
    style: {
      stopColor: "#6DC067"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    style: {
      stopColor: "#007F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007F53"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000117646226540142345840000016572236688491890818_)",
      fill: "url(#SVGID_00000074407804821705941590000000574859568211470771_)"
    },
    points: " 25.1,56.1 47.3,22 76.3,41 54.1,75  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000147908497216134936980000000823870031381698708_)"
    }
  }, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000067949775183890506980000017491165082245283764_",
    d: "M62.3,22l-2.5,2c-1.8,1.4-2.7,3.8-2.2,6.1l5.5,27.6 c6.8-8,9.2-19.3,5.4-29.9c-0.6-1.8-1.4-3.5-2.4-5.1c-0.5-0.8-1.3-1.3-2.2-1.3C63.4,21.5,62.8,21.6,62.3,22"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000146501550819091653570000005613720616133819820_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067949775183890506980000017491165082245283764_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179634629998890872890000014700342890932480144_",
    gradientUnits: "userSpaceOnUse",
    x1: -548.9598,
    y1: -325.5749,
    x2: -547.8981,
    y2: -325.5749,
    gradientTransform: "matrix(23.4602 -35.9498 -35.9498 -23.4602 1225.2955 -27312.3359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6DC067"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09470549,
    style: {
      stopColor: "#6DC067"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    style: {
      stopColor: "#007F53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007F53"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000146501550819091653570000005613720616133819820_)",
      fill: "url(#SVGID_00000179634629998890872890000014700342890932480144_)"
    },
    points: " 40.6,46.8 61.7,14.5 88.9,32.3 67.8,64.6  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000147908497216134936980000000823870031381698708_)"
    }
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000100370277045239874480000011005002506696239757_",
    x: 9.5,
    y: 7.4,
    width: 301.9,
    height: 61
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016046172939859655550000004879335832245614764_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000100370277045239874480000011005002506696239757_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000016046172939859655550000004879335832245614764_)",
      fill: "#455E2A"
    },
    d: "M105.2,35.3 c-0.4-0.2-0.7-0.3-1-0.5c-2.7-1.5-5.4-3.1-5.4-5.9c0-3.1,3.4-4.2,6.3-4.2c2.4,0,4.7,1,5.9,1.6c0.4,0.2,0.9,0.1,1.2-0.3l0.2-0.2 c0.2-0.2,0.2-0.5,0.2-0.8c0-0.3-0.2-0.5-0.4-0.6c-1.5-0.9-4.5-2.5-8.3-2.5c-5.7,0-11.7,3.4-11.7,9.7c0,5.5,5.2,8.2,9,10.2 c0.8,0.4,1.5,0.8,2.1,1.1c3.4,2,3.9,3,3.9,5.3c0,2.6-2,4.1-5.6,4.1c-3.9,0-7.3-1.7-8.6-2.4c-0.4-0.2-0.9-0.1-1.1,0.3l-0.3,0.4 c-0.3,0.4-0.2,0.9,0.2,1.2c1.5,1.1,5.5,3.6,10.6,3.6c3.2,0,6.2-0.9,8.3-2.5c2.3-1.8,3.5-4.3,3.5-7.4 C114.1,39.7,108.3,36.8,105.2,35.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000016046172939859655550000004879335832245614764_)",
      fill: "#455E2A"
    },
    d: "M128.2,30.2 c-5.7,0-8.8,2.7-9.9,3.8c-0.1,0.1-0.2,0.3-0.2,0.5c0,0.2,0.1,0.4,0.2,0.5l0.6,0.5c0.3,0.2,0.7,0.3,1,0c2.4-1.8,4.5-2.3,5.8-2.3 c1.4,0,2.9,0.1,4.1,1.4c1.3,1.4,1.3,3.7,1.3,3.7v2.8h-3.7c-8,0-10.9,3.7-10.9,7.1c0,1.7,0.7,3.3,2,4.5c1.5,1.3,3.8,2.1,6.5,2.1 c4.7,0,6.4-2.1,6.9-3.1c1,2.6,3.2,3.1,4.5,3.1c0.7,0,1.2-0.2,1.5-0.5c0.3-0.4,0.3-0.8,0.3-0.8V40.3 C138.4,35.6,135.7,30.2,128.2,30.2 M127.1,52.2l-0.2,0c-0.5,0-2.9-0.7-2.9-4c0-3,2.2-5,5.4-5h1.8V46c0,1.2,0,3.5-1.4,4.9 C128.5,52.3,127.7,52.2,127.1,52.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000016046172939859655550000004879335832245614764_)",
      fill: "#455E2A"
    },
    d: "M271.1,30.2 c-5.7,0-8.8,2.7-9.9,3.8c-0.1,0.1-0.2,0.3-0.2,0.5c0,0.2,0.1,0.4,0.2,0.5l0.6,0.5c0.3,0.2,0.7,0.3,1,0c2.4-1.8,4.5-2.3,5.8-2.3 c1.4,0,2.9,0.1,4.1,1.4c1.3,1.4,1.3,3.7,1.3,3.7v2.8h-3.7c-8,0-10.9,3.7-10.9,7.1c0,1.7,0.7,3.3,2,4.5c1.5,1.3,3.8,2.1,6.5,2.1 c4.7,0,6.4-2.1,6.9-3.1c1,2.6,3.2,3.1,4.5,3.1c0.7,0,1.2-0.2,1.5-0.5c0.3-0.4,0.3-0.8,0.3-0.8V40.3 C281.2,35.6,278.6,30.2,271.1,30.2 M274,43.2V46c0,1.2,0,3.5-1.4,4.9c-1.3,1.4-2.1,1.4-2.7,1.3l-0.2,0c-0.5,0-2.9-0.7-2.9-4 c0-3,2.2-5,5.4-5H274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000016046172939859655550000004879335832245614764_)",
      fill: "#455E2A"
    },
    d: "M171.3,30.4 c-5.1,0-7,3.3-7.7,4.8c-0.3-1.6-1.5-4.8-6.5-4.8c-4.4,0-6.5,3-7.2,4.5v-3.6c0-0.2-0.2-0.4-0.4-0.4h-6.2c-0.2,0-0.4,0.2-0.4,0.4 v22.9c0,0.2,0.2,0.4,0.4,0.4h6.2c0.2,0,0.4-0.2,0.4-0.4V40.6c0-1.2,0.6-2.9,1.5-4.4c1-1.6,2.2-2.5,3.2-2.5c2.2,0,2.3,2.8,2.3,2.9 v17.2c0,0.4,0.3,0.7,0.7,0.7h5.5c0.4,0,0.7-0.3,0.7-0.7V40.9c0-3,2.3-7.1,4.6-7.1c2.2,0,2.3,2.9,2.3,3v17c0,0.4,0.3,0.7,0.7,0.7 h5.5c0.4,0,0.7-0.3,0.7-0.7V40.3V40c0-2.2,0-5.9-2.1-8C174.7,30.9,173.2,30.4,171.3,30.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000016046172939859655550000004879335832245614764_)",
      fill: "#455E2A"
    },
    d: "M202.9,30.9H198 c-0.6,0-1.1,0.5-1.1,1.1v9.3c0,6.2-2.7,10-5.1,10c-0.6,0-1.1-0.2-1.5-0.6c-1-1-1-3-1-3V31.9c0-0.6-0.5-1-1-1h-5.1 c-0.6,0-1,0.5-1,1l0,15.4c0,0.1-0.4,3.1,1.5,5.3c1.3,1.5,3.3,2.2,6,2.2c4.2,0,6.3-2,7.4-3.8c0.6,2.1,2.6,3.6,4.9,3.6h0.9 c0.6,0,1.1-0.5,1.1-1.1V32C203.9,31.4,203.5,30.9,202.9,30.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000016046172939859655550000004879335832245614764_)",
      fill: "#455E2A"
    },
    d: "M228.3,32.5 c-1.3-1.4-3.1-2.1-5.5-2.1c-1.1,0-4.5,0-7.2,4.6v-3.2c0-0.4-0.3-0.8-0.8-0.8h-5.2c-0.6,0-1.1,0.5-1.1,1.1v21.6 c0,0.6,0.5,1.1,1.1,1.1h4.9c0.6,0,1.1-0.5,1.1-1.1V43.7c0-6.2,2.7-10,5.1-10c0.6,0,1.1,0.2,1.5,0.6c1,1,1,3,1,3v16.5 c0,0.6,0.5,1,1,1h5.1c0.6,0,1-0.5,1-1V38.4C230.4,38.3,230.6,34.8,228.3,32.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000016046172939859655550000004879335832245614764_)",
      fill: "#455E2A"
    },
    d: "M254.5,32.5 c-1.3-1.4-3.1-2.1-5.5-2.1c-1.1,0-4.5,0-7.2,4.6v-3.2c0-0.4-0.3-0.8-0.8-0.8h-5.2c-0.6,0-1.1,0.5-1.1,1.1v21.6 c0,0.6,0.5,1.1,1.1,1.1h4.9c0.6,0,1.1-0.5,1.1-1.1V43.7c0-6.2,2.7-10,5.1-10c0.6,0,1.1,0.2,1.5,0.6c1,1,1,3,1,3v16.5 c0,0.6,0.5,1,1,1h5.1c0.6,0,1-0.5,1-1V38.4C256.6,38.3,256.8,34.8,254.5,32.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000016046172939859655550000004879335832245614764_)",
      fill: "#455E2A"
    },
    d: "M299.6,51.8 c-0.2-0.4-0.6-0.5-1-0.3c-0.5,0.2-1.2,0.5-2.1,0.5c-2.1,0-2.6-2.8-2.6-5.1V33.4h4.6c0.4,0,0.8-0.4,0.8-0.8v-1 c0-0.4-0.4-0.8-0.8-0.8h-4.6v-7.2h-2.2l0,0.2c0,0-0.4,3.2-2.2,5c-1.4,1.4-3.7,1.9-4.7,2c-0.4,0.1-0.8,0.5-0.8,0.9v0.9 c0,0.5,0.4,0.9,0.9,0.9h1.9v14.2c0,0.1-0.1,3,1.9,5.1c1.3,1.3,3.1,2,5.5,2c0.2,0,3.7,0,5.5-1.5c0.3-0.2,0.3-0.6,0.2-0.9 L299.6,51.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000016046172939859655550000004879335832245614764_)",
      fill: "#455E2A"
    },
    d: "M309.3,30.8h-6.4 c-0.2,0-0.4,0.2-0.4,0.4v23c0,0.2,0.2,0.4,0.4,0.4h6.4c0.2,0,0.4-0.2,0.4-0.4v-23C309.7,31,309.5,30.8,309.3,30.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000016046172939859655550000004879335832245614764_)",
      fill: "#455E2A"
    },
    d: "M306.1,28.8 c2.2,0,4-1.8,4-4s-1.8-4-4-4c-2.2,0-4,1.8-4,4S303.9,28.8,306.1,28.8"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a033e4932976e4e56bf93cd1f3f7ad03.svg";
export { ForwardRef as ReactComponent };